export default __webpack_public_path__ + "static/media/Group -12-Yono@2x.c8ae659a.png";